import { Alert } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'

const InfoReplacingCompensatoryRest = () => {
  const { t } = usePlanningFormTranslation()

  return (
    <Alert intent='semantic.blue' className='mt-3'>
      {t('restForm.infoReplacingCompensatoryRest')}
    </Alert>
  )
}

export default InfoReplacingCompensatoryRest
